









































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { EditorialProject, FileExport, Product, SearchProductOptions, SearchProductOptionsMultiples, SearchResult } from '@/models'
import { CvValueUtils } from '@/utils/cv-value-utils'
import {
  ACCOUNT_ACTIONS_BUTTON_DELETE_PRODUCT,
  ACCOUNT_ACTIONS_BUTTON_EDIT_PRODUCT_STATUS_TYPE,
  ACCOUNT_ACTIONS_BUTTON_NEW_PRODUCT,
  CV_VALUE_EDUCATION,
  CV_VALUE_TYPE_PROD,
  DEFAULT_ICON_PRODUCT,
  ROLE_SPECIAL,
  SECURITY_ACTION_REMOVE
} from '@/utils/constants'
import { ActionTypes } from '@/store/action-types'
import { MutationTypes } from '@/store/mutation-types'
import { Utils } from '@/utils'

@Component({
  components: {
    UpsertProductModal: () => import('@/components/modals/UpsertProductModal.vue'),
    BulkCreateProductsModal: () => import('@/components/modals/BulkCreateProductsModal.vue'),
    ProductListFilters: () => import('@/components/ProductListFilters.vue'),
    UpsertProductStatusTypeModal: () => import('@/components/modals/UpsertProductStatusTypeModal.vue'),
    TypeIcon: () => import('@/components/TypeIcon.vue'),
    ProductDetailModal: () => import('@/components/modals/ProductDetailModal.vue'),
    ProductHistoricalModal: () => import('@/components/modals/ProductHistoricalModal.vue')
  }
})
export default class Products extends Vue {
  private Utils = Utils
  public ROLE_SPECIAL = ROLE_SPECIAL
  public ACCOUNT_ACTIONS_BUTTON_NEW_PRODUCT = ACCOUNT_ACTIONS_BUTTON_NEW_PRODUCT
  public ACCOUNT_ACTIONS_BUTTON_EDIT_PRODUCT_STATUS_TYPE = ACCOUNT_ACTIONS_BUTTON_EDIT_PRODUCT_STATUS_TYPE
  public ACCOUNT_ACTIONS_BUTTON_DELETE_PRODUCT = ACCOUNT_ACTIONS_BUTTON_DELETE_PRODUCT
  public SECURITY_ACTION_REMOVE = SECURITY_ACTION_REMOVE
  public CV_VALUE_EDUCATION = CV_VALUE_EDUCATION
  public CV_VALUE_TYPE_PROD = CV_VALUE_TYPE_PROD
  public defaultPageSize = 100

  private searchResult: SearchResult = {
    items: [],
    totalResults: 0,
    pageSize: this.defaultPageSize,
    pageOffset: 1
  }

  private filters: SearchProductOptionsMultiples = {
    educationLevel1: [],
    manager: [],
    type: [],
    search: '',
    country: [],
    editorialProject: [],
    workType: [],
    subject: [],
    offset: 0,
    limit: 0,
    relatedToDigital: null,
    editorialProjectYearStart: [],
    productionCampaign: [],
    language: [],
    educationLevel2: []
  }

  private currentPage = this.$router.currentRoute.query.currentPage ? parseInt(this.$router.currentRoute.query.currentPage.toString()) : 1

  // Modals params
  private productUpdate: Product | null = null
  private productSelected: Product | null = null
  private productHistoricalSelected: Product | null = null

  private fields = [
    { key: 'code', label: `${this.$t('product_view.table.header.code')}` },
    { key: 'metadata.educationLevel1', label: `${this.$t('product_view.table.header.stage')}` },
    { key: 'metadata.subjectLabel', label: `${this.$t('product_view.table.header.subject')}` },
    { key: 'name', label: `${this.$t('product_view.table.header.title')}` },
    { key: 'metadata.developmentManager', label: `${this.$t('product_view.table.header.manager')}` },
    { key: 'editorialProject', label: `${this.$t('product_view.table.header.editorial_project')}` },
    { key: 'metadata', label: '' }
  ]

  @Watch('currentPage')
  onCurrentPageChanged() {
    this.search()
  }

  get editorialProjects() {
    return this.$store.getters.editorialProjects
  }

  private search(exportList = false) {
    this.$store.commit(MutationTypes.SET_LOADING, true)
    let subject = null
    if (this.filters.subject && this.filters.subject?.length > 0) {
      subject = this.filters.subject.map((item) => item.split('-')[1]).join(',')
    }
    let language = null
    if (this.filters.language && this.filters.language?.length > 0) {
      language = this.filters.language.map((item) => item.split('-')[1]).join(',')
    }
    let educationLevel2 = null
    if (this.filters.educationLevel2 && this.filters.educationLevel2?.length > 0) {
      educationLevel2 = this.filters.educationLevel2.map((item) => item.split('-')[1]).join(',')
    }
    const searchOptions: SearchProductOptions = {
      search: this.filters.search,
      offset: (this.currentPage - 1) * this.defaultPageSize,
      limit: this.defaultPageSize,
      educationLevel1: (this.filters.educationLevel1 && this.filters.educationLevel1?.length > 0) ? this.filters.educationLevel1.join(',') : null,
      manager: (this.filters.manager && this.filters.manager?.length > 0) ? this.filters.manager.join(',') : null,
      type: (this.filters.type && this.filters.type?.length > 0) ? this.filters.type.join(',') : null,
      country: (this.filters.country && this.filters.country?.length > 0) ? this.filters.country.join(',') : null,
      subject: subject,
      editorialProject: (this.filters.editorialProject && this.filters.editorialProject?.length > 0) ? this.filters.editorialProject.join(',') : null,
      workType: (this.filters.workType && this.filters.workType?.length > 0) ? this.filters.workType.join(',') : null,
      relatedToDigital: null,
      editorialProjectYearStart: null,
      productionCampaign: (this.filters.productionCampaign && this.filters.productionCampaign?.length > 0) ? this.filters.productionCampaign.join(',') : null,
      language: language,
      educationLevel2: educationLevel2,
      export: exportList
    }

    if (!exportList) {
      ApiClient.searchProducts(searchOptions)
        .then(async(result) => {
          this.searchResult = result
          if (result.totalResults < result.pageOffset) {
            this.currentPage = 1
            this.search()
          }
        })
        .catch((e) => {
          console.error(e)
        }).finally(() => {
          this.$store.commit(MutationTypes.SET_LOADING, false)
        })
    } else {
      this.$store.commit(MutationTypes.SET_LOADING, true)
      ApiClient.searchProducts(searchOptions)
        .then((file: FileExport) => {
          Utils.exportFile(file.file, file.fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
          this.$store.dispatch(ActionTypes.SHOW_TOAST, {
            title: this.$t('product_view.feedback.download_success_title'),
            variant: 'success',
            message: this.$t('product_view.feedback.download_success_message')
          })
          this.$store.commit(MutationTypes.SET_LOADING, false)
        })
        .catch(() => {
          this.$store.dispatch(ActionTypes.SHOW_TOAST, {
            title: this.$t('feedback.error_title_generic'),
            variant: 'danger',
            message: this.$t('feedback.error_message_generic')
          })
          this.$store.commit(MutationTypes.SET_LOADING, false)
        })
    }
  }

  private productCreated() {
    this.search()
  }

  private resetSearch() {
    this.filters.educationLevel1 = []
    this.filters.manager = []
    this.filters.type = []
    this.filters.country = []
    this.filters.editorialProject = []
    this.filters.workType = []
    this.filters.subject = []
    this.filters.language = []
    this.filters.educationLevel2 = []
    this.filters.search = ''
    this.currentPage = 1
    this.search()
  }

  private getCvValueName(codeId: string, type: string = CV_VALUE_EDUCATION) {
    const typeName = CvValueUtils.getCvValueName(codeId, type)
    if (typeName === codeId) {
      return ''
    }
    return typeName
  }

  private getCvValueProductIcon(codeId: string) {
    const cvValue = CvValueUtils.getCvValue(codeId, CV_VALUE_TYPE_PROD)
    if (!cvValue || !cvValue.icon) {
      return DEFAULT_ICON_PRODUCT
    }
    return cvValue.icon
  }

  private getEditorialProjectName(product: Product) {
    const editorialProjectFind = this.editorialProjects.find((item: EditorialProject) => item.id === product.editorialProject)
    if (editorialProjectFind) {
      return this.editorialProjects.find((item: EditorialProject) => item.id === product.editorialProject).name
    } else {
      return ''
    }
  }

  deleteProduct(product: Product) {
    this.$bvModal.msgBoxConfirm(this.$t('product_view.modal_delete.message') as string, {
      title: this.$t('product_view.modal_delete.title') as string,
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'danger',
      okTitle: this.$t('button_actions.confirm') as string,
      cancelVariant: 'light',
      cancelTitle: this.$t('button_actions.cancel') as string,
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true
    }).then(value => {
      if (value) {
        this.deleteProductApi(product)
      }
    }).catch(err => {
      console.log(err)
    })
  }

  deleteProductApi(product: Product) {
    const payload = { delete: true }
    this.$store.commit(MutationTypes.SET_LOADING, true)
    ApiClient.updateProduct(product.code, payload)
      .then(() => {
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('product_view.feedback.delete_success_title'),
          variant: 'success',
          message: this.$t('product_view.feedback.delete_success_message')
        })
        this.search()
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
      .catch(() => {
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('feedback.error_title_generic'),
          variant: 'danger',
          message: this.$t('feedback.error_message_generic')
        })
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
  }

  setModalUpsertProduct() {
    this.productUpdate = Object.assign({}, null)
    this.$bvModal.show('UpsertProductModal')
  }

  setModalUpdateProduct(product: Product) {
    this.productUpdate = Object.assign({}, product)
    this.$bvModal.show('UpsertProductModal')
  }

  setModalUpdateProductStatusType(product: Product) {
    this.productUpdate = Object.assign({}, product)
    this.$bvModal.show('UpsertProductStatusTypeModal')
  }

  private setProductDetailModal(product: Product) {
    this.productSelected = Object.assign({}, product)
    this.$bvModal.show('ProductDetailModal')
  }

  private setProductHistoricalModal(product: Product) {
    this.productHistoricalSelected = Object.assign({}, product)
    this.$bvModal.show('productHistoricalModal')
  }

  private closePopover(id: string) {
    this.$root.$emit('bv::hide::popover', id)
  }
}
